export const ROUTES = {
  // ─── Tabs ───
  TABS_ROOT: '/dashboard' as const,
  TABS_DASHBOARD: '/dashboard' as const,
  TABS_CHAT: '/chat' as const,
  TABS_LIBRARY: '/library' as const,
  TABS_DOCUMENTS: '/documents' as const,
  TABS_PLATFORM_ADMIN: '/more/platform-admin' as const,
  TABS_SCHOOL_MANAGEMENT: '/more/school-management' as const,
  TABS_MORE: '/more' as const,
  TABS_MORE_PLATFORM_ADMIN: '/more/platform-admin' as const,
  TABS_MORE_SCHOOL_MANAGEMENT: '/more/school-management' as const,
  TABS_MORE_LIBRARY: '/more/library' as const,
  TABS_STUDENTS: '/students' as const,
  TABS_PROGRESS: '/progress' as const,
  TABS_MENTOR_TRAINING: '/mentor-training' as const,

  // ─── Standalone screens ───
  MCS_PREPARATION: '/mentor/mcs-preparation' as const,
  MENTOR_ENGAGEMENTS: '/mentor/engagements' as const,
  MENTOR_ENGAGEMENT_DETAIL: '/mentor/engagements/[id]' as const,
  MENTOR_TRAINING_DRILL: '/mentor-training/drill' as const,
  MENTOR_TRAINING_INSTRUCTOR_DRILL: '/mentor-training/instructor' as const,
  ADMIN_CREATE_SCHOOL: '/admin/create-school' as const,
  PROFILE: '/profile' as const,
  /** The canonical per-session report (D0). Navigate with `reportRoute(id)`. */
  REPORT: '/report/[sessionId]' as const,
  PROGRESS_DATA_MANAGEMENT: '/progress/data-management' as const,
  PROGRESS_COMPETENCY_DETAIL: '/progress/competency-detail' as const,
  PROGRESS_PRACTICE_EXAM: '/progress/practice-exam' as const,
  ACTIVATION_UPLOAD_FIRST_SESSION: '/activation/upload-first-session' as const,
  ACTIVATION_PRACTICE_SESSION: '/activation/practice-session' as const,

  // ─── Public (unauthenticated) routes ───
  PUBLIC_LOGIN: '/login' as const,
  PUBLIC_REGISTER: '/register' as const,
  PUBLIC_ACCEPT_INVITATION: '/accept-invitation' as const,
  PUBLIC_MAGIC_LINK_CONSUME: '/auth/magic-link' as const,
  PUBLIC_CONFIRM_EMAIL_CHANGE: '/confirm-email-change' as const,
  PUBLIC_SIGNUP: '/(public)/signup' as const,

  // ─── Gated (authenticated but incomplete) routes ───
  GATED_TERMS_ACCEPTANCE: '/(gated)/terms-acceptance' as const,
  GATED_ONBOARDING: '/(gated)/onboarding' as const,
  GATED_PLAN_SELECTION: '/(gated)/plan-selection' as const,
  GATED_BILLING_RECOVERY: '/(gated)/billing-recovery' as const,
  GATED_POST_PAYMENT_ONBOARDING: '/(gated)/post-payment-onboarding' as const,
  GATED_B2B_PLAN_SELECTION: '/(gated)/b2b-plan-selection' as const,
  GATED_SCHOOL_INACTIVE: '/(gated)/school-inactive' as const,
} satisfies Record<string, string>;

export type AppRoute = typeof ROUTES[keyof typeof ROUTES];

/** Router target for the canonical report screen of one analysed session. */
export function reportRoute(sessionId: number | string) {
  return { pathname: ROUTES.REPORT, params: { sessionId: String(sessionId) } };
}

/** Analysis sessions open their report; every other session opens its chat. */
export function isAnalysisSession(session: { session_type?: string | null }): boolean {
  return session.session_type === 'analysis';
}

export function sessionRoute(session: { id: number | string; session_type?: string | null }) {
  return isAnalysisSession(session)
    ? reportRoute(session.id)
    : { pathname: ROUTES.TABS_CHAT, params: { sessionId: String(session.id) } };
}
